export default class ElementIdGenerator {
  static counter = 0;

  static next() {
    return ++this.counter;
  }

  static setCounter(value) {
    this.counter = Math.max(this.counter, parseInt(value));
  }
}
